import React from 'react';

import classNames from 'classnames/bind';
import style from './Map.scss';
const ctx = classNames.bind(style);

import ReadMoreLink from '../ReadMoreLink';
import GoogleMaps from './blocks/GoogleMaps';

const DEFAULT_CENTER = [59.838043, 30.337157];

const PLACES = [
  {
    id: 'A',
    lat: 59.955413,
    lng: 30.337844,
    photo: 'images/media/obj1.png',
    name: 'Квартал «Искра Парк»',
    description: (
      <div>
        Адрес: Москва, Ленинградский пр-т, вл. 35 <br />
        Общая площадь: 234 400 м2 <br />
        Готовность: IV квартал 2018 г <br />
        Сайт объекта:{' '}
        <a href="http://www.iskra-park.ru">http://www.iskra-park.ru</a>
      </div>
    ),
    mapCenter: {
      lat: 60.2,
      lng: 30.337844,
    },
  },
  {
    id: 'B',
    lat: 59.724,
    lng: 30.08,
    photo: 'images/media/obj1.png',
    name: 'Квартал «Вымпел Парк»',
    description: (
      <div>
        Адрес: Москва, Ленинградский пр-т, вл. 35 <br />
        Общая площадь: 234 400 м2 <br />
        Готовность: IV квартал 2018 г <br />
        Сайт объекта:{' '}
        <a href="http://www.iskra-park.ru">http://www.iskra-park.ru</a>
      </div>
    ),
    mapCenter: {
      lat: 60,
      lng: 30.08,
    },
  },
];

class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleSelectPlace = id => {
    this.setState({
      selectedId: id,
    });
  };

  handleResetSelectPlace = () => {
    this.setState({
      selectedId: null,
    });
  };

  handleCenterChange = mapCenter => {
    this.setState({
      mapCenter,
    });
  };

  render() {
    const { selectedId, mapCenter } = this.state;

    return (
      <div className={ctx('map')}>
        <div className={ctx('google')}>
          <GoogleMaps
            zoom={9}
            center={mapCenter || DEFAULT_CENTER}
            selectedId={selectedId}
            greatPlaces={PLACES}
            onSelectPlace={this.handleSelectPlace}
            onResetSelectPlace={this.handleResetSelectPlace}
            onCenterChange={this.handleCenterChange}
          />
        </div>
        <div className={ctx('link')}>
          <ReadMoreLink title={'Перейти на гугл-карту'} link={'#'} />
        </div>
      </div>
    );
  }
}

export default Map;

// https://snazzymaps.com

/*

https://github.com/google-map-react/google-map-react

https://github.com/tomchentw/react-google-maps

*/
